import PropTypes from 'prop-types';
import React from 'react';
import { Auth } from 'aws-amplify';
import { get } from 'lodash';
import { push } from 'connected-react-router';
import { connect, useDispatch } from 'react-redux';
import { SideNavigation } from '@amzn/awsui-components-react/polaris';
import { getNavBarHeaderConfig, NAVBAR_ITEMS_CONFIG, SIGN_OUT_HREF } from './constants';
import { getStudyPeriod } from '../../../../constants/study_period';
import { ENTITY_ID_VALUES } from '../../../../../redux/reducers/entityIdReducers';
import { setEntityId } from '../../../../../redux/actions/entityIdActions';
import { setStudyType } from '../../../../../redux/actions/studyTypeActions';
import { ROUTE_PATH } from '../../../../constants/route_paths';

const NavBar = props => {
  const dispatch = useDispatch();
  const onFollowHandler = event => {
    event.preventDefault();

    if (event.detail.href && props) {
      const { navigateTo } = props;
      const { href } = event.detail;

      if (href === SIGN_OUT_HREF) {
        Auth.signOut();
      } else if (navigateTo) {
        if (href === ROUTE_PATH.ORBIT_PAGE) {
          navigateTo(href);
          return;
        }

        const hrefSplit = href.split('/');
        const studyType = hrefSplit[1];
        dispatch(setStudyType(studyType));
        hrefSplit.splice(1, 1);
        const isEntityId = ENTITY_ID_VALUES.includes(hrefSplit[1]);
        if (isEntityId) {
          const entityId = hrefSplit[1];
          dispatch(setEntityId(entityId));
          hrefSplit.splice(1, 1);
        }
        navigateTo(hrefSplit.join('/'));
      }
    }
  };

  const { currentPathName, studyPeriod, entityId, studyType } = props;
  return (
    <SideNavigation
      activeHref={
        entityId ? `/${studyType}/${entityId}${currentPathName}` : `/${studyType}${currentPathName}`
      }
      onFollow={onFollowHandler}
      header={getNavBarHeaderConfig(studyPeriod, entityId === undefined)}
      items={NAVBAR_ITEMS_CONFIG}
    />
  );
};

NavBar.propTypes = {
  navigateTo: PropTypes.func.isRequired,
  currentPathName: PropTypes.string.isRequired,
  studyPeriod: PropTypes.string.isRequired,
  entityId: PropTypes.string,
  studyType: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  return {
    currentPathName: get(state, 'router.location.pathname'),
    studyPeriod: getStudyPeriod(state),
    entityId: get(state, 'entityId.entityId'),
    studyType: get(state, 'studyType.studyType'),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    navigateTo: payload => dispatch(push(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
